var _path, _circle, _circle2, _circle3, _circle4, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41843 5.46302C4.24834 5.63463 4.24958 5.91164 4.42119 6.08173C4.59281 6.25182 4.86981 6.25059 5.0399 6.07897L6.05917 5.05057C6.47283 4.6332 6.75752 4.3469 6.99874 4.15318C7.23307 3.96499 7.38358 3.90043 7.51837 3.88325C7.60301 3.87246 7.68865 3.87246 7.77329 3.88325C7.90809 3.90043 8.0586 3.96499 8.29292 4.15317C8.53415 4.3469 8.81884 4.6332 9.2325 5.05057L10.2518 6.07897C10.4219 6.25059 10.6989 6.25182 10.8705 6.08173C11.0421 5.91164 11.0433 5.63463 10.8732 5.46302L9.83561 4.41609C9.44481 4.02178 9.12541 3.6995 8.84082 3.47094C8.54488 3.23328 8.24449 3.06123 7.88393 3.01528C7.72583 2.99512 7.56584 2.99512 7.40774 3.01528C7.04717 3.06123 6.74679 3.23328 6.45085 3.47094C6.16626 3.6995 5.84686 4.02177 5.45606 4.41609L4.41843 5.46302Z",
    fill: "#2F3259"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 10.5,
    r: 0.5,
    fill: "#2F3259"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 10.5,
    r: 0.5,
    fill: "#2F3259"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 10.5,
    r: 0.5,
    fill: "#2F3259"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 10.5,
    r: 0.5,
    fill: "#2F3259"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 10.5,
    r: 0.5,
    fill: "#2F3259"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.dbd3cd9cc54b4352e7ec0015486bdf92.svg";
export { ForwardRef as ReactComponent };